module.exports = __webpack_public_path__ + "img/trading4.aa8fcb07.svg";